import { Fragment, useContext, useRef, useState,useEffect } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { PlusIcon } from "@heroicons/react/outline";
import AuthContext from "../../AuthContext";
import "react-country-state-city/dist/react-country-state-city.css";
import axiosInstance from '../../axios'
import {toast} from 'react-toastify'
import MultiCourse from '../Dropdowns/MultiCourse'

export default function AddProduct({
  addProductModalSetting,
  handlePageUpdate,
}) {
  const authContext = useContext(AuthContext);
  const [photo,setPhoto]=useState('')
  const imp=true
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const[gender,setGender]=useState('')
const [mStatus,setMStatus]=useState('')
const [course,setCourse]=useState('')
const[adhar,setAdhar]=useState('')
const[pan,setPan]=useState('')
const[cv,setCV]=useState('')
const[qual,setQual]=useState('')
const[exp,setExp]=useState('')
const[tot,setTot]=useState('')
const [currentCode, setCurrentCode] = useState(''); // Starting point
  const [trainer, setTrainer] = useState({
  fname:'',
  mname:'',  
  lname:'',
  mo_no:'',
  email:'',
  address:'',
  district:'',
  qualification:'',
  experience:'',
  dob:'',
   alt_mob_no:'',
  alt_email:'',
  aadhar_no:'',
  status:'',
  payment:'',
  pan_no:'',
  username:'',
  password:''
});
const resetForm=()=>{
  setTrainer({
    fname:'',
    mname:'',  
    lname:'',
    mo_no:'',
    email:'',
    address:'',
    district:'',
    qualification:'',
    experience:'',
    dob:'',
     alt_mob_no:'',
    alt_email:'',
    aadhar_no:'',
    status:'',
    payment:'',
    pan_no:'',
    username:'',
    password:''
  },
  setCV(''),
  setGender(''),
  setAdhar(''),
  setMStatus(''),
  setQual(''),
  setExp(''),
  setPhoto(''),
  setPan(''),
  setSelectedCourses(''),
  setTot('')
)
    
    
}
  const [open, setOpen] = useState(true);
  const cancelButtonRef = useRef(null);
  useEffect(() => {
    const generateCurrentCode = () => {
      // Extract the last 4 digits of the mobile number
      const moNoLast4 = trainer.mo_no.slice(-3);
      
      // Extract the last 3 digits of the Aadhar number
      const aadharNoLast3 = trainer.aadhar_no.slice(-3);
      
      // Combine them to form the current code
      return `TR-${moNoLast4}${aadharNoLast3}`;
    };
  
    setCurrentCode(generateCurrentCode());
  }, [trainer.mo_no, trainer.aadhar_no]);
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setTrainer(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleFileChange=(e)=>{
    setPhoto(e.target.files[0])
  }
  const [selectedCourses, setSelectedCourses] = useState([]);
  const handleCourseChange = (newSelectedCourses) => {
    setSelectedCourses(newSelectedCourses);
  };
  const addTrainer= () => {
    setIsButtonDisabled(true); 
const requiredFields={
  "First Name":trainer.fname,
  "Middle Name":trainer.mname,
  "Last Name":trainer.lname,
  "Mobile No":trainer.mo_no,
  "Email":trainer.email,
  "Address":trainer.address,
  "District":trainer.district,
  "Qualification":trainer.qualification,
  "Experience":trainer.experience,
  "Course":selectedCourses,
  "Marital Status":mStatus,
  "Date of Birth":trainer.dob,
  "Payment":trainer.payment,
  "Aadhar No":trainer.aadhar_no,
  "PAN No":trainer.pan_no,
  "CV":cv,
  "PAN No":pan,
  "Aadhar Card":adhar,
  "PAN Card":pan,
  "Qualification Certificate":qual,
  "Experience Certificate":exp,
  "username":trainer.username,
  "password":trainer.password,
  "ToT Certificate":tot
}
  // Regular expression for validating email format
const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

// Validate required fields and email format
const missingFields = Object.keys(requiredFields).filter(key => {
  const field = requiredFields[key];
  
  // Check if the field is empty or an empty array
  if (!field || (Array.isArray(field) && field.length === 0)) {
    return true;
  }
  
  // Validate email fields
  if ((key === "Email") && !emailPattern.test(field)) {
    toast.error('Enter Valid Email ID')
    return true;
  }
  
  return false;
});

if (missingFields.length > 0) {
  toast.error(`Please fill in all required fields: ${missingFields.join(', ')}`);
  setIsButtonDisabled(false)
  return;
}
  
    const formatDate = (dateString) => {
      const date = new Date(dateString);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    };
    
    const formData=new FormData()
    formData.append('photo',photo)
    formData.append('fname', trainer.fname);
    formData.append('mname', trainer.mname);
    formData.append('lname', trainer.lname);  
    formData.append('mob_no', trainer.mo_no);
    formData.append('email', trainer.email);
    formData.append('address', trainer.address);
    formData.append('district', trainer.district);
    formData.append('qualification', trainer.qualification);
    formData.append('experience', trainer.experience);
    formData.append('course_id',selectedCourses); 
    formData.append('marital_status', mStatus);
    formData.append('dob', formatDate(trainer.dob));
    formData.append('gender', gender);
    formData.append('status',trainer.status)
    formData.append('alt_mob_no', trainer.alt_mob_no);
    formData.append('alt_email', trainer.alt_email);
    formData.append('aadhar_no', trainer.aadhar_no);
    formData.append('aadhar_card',adhar)
    formData.append('payment', trainer.payment);
    formData.append('pan_no', trainer.pan_no);
    formData.append('cv', cv)
    formData.append('pan_card', pan)
    formData.append('qualification_certificate',qual)
    formData.append('experience_certificate',exp)
    formData.append('trainer_code',currentCode)
    formData.append('username', trainer.username);
    formData.append('password',trainer.password)
    formData.append('tot_document',tot)
    axiosInstance.post('/trainer/insert' ,formData)      
    .then((result) => {
        toast.success("Trainer Added Successfully")
        handlePageUpdate()
        resetForm()
      })
      .catch((err) => {
        toast.error("Failed to Add Trainer");
        console.log(err);
      })
      .finally(() => {
        setIsButtonDisabled(false); // Re-enable the button after toast is displayed
      });
  };
 

  return (
    // Modal
    <Transition.Root show={open} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-10"
        initialFocus={cancelButtonRef}
        onClose={setOpen}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-4xl">
                <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                  <div className="sm:flex sm:items-start">
                    <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-blue-100 sm:mx-0 sm:h-10 sm:w-10">
                      <PlusIcon
                        className="h-6 w-6 text-blue-400"
                        aria-hidden="true"
                      />
                    </div>
                    <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left ">
                      <Dialog.Title
                        as="h3"
                        className="text-lg font-semibold leading-6 text-gray-900 "
                      >
                        Add Trainer
                      </Dialog.Title>
                      <form action="#">
                        <div className="grid gap-4 mb-4 sm:grid-cols-4">
                        <div>
                            <label htmlFor="photo"
                            className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >Profile Photo <span className='text-red-500'> *</span></label>
                            <label
        htmlFor="photo"
        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"      >
        <svg
          className="w-6 h-5 inline-block mr-2"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3 16V21H21V16H3ZM5 18H19V16H5V18ZM3 6H21V14H3V6ZM5 10H19V8H5V10Z"
            fill="currentColor"
          />
        </svg>
        <span className="inline-block">
          {" "}
          {photo?.name && photo.name.length > 8
            ? photo.name.substring(0, 8) + "..."
            : photo?.name || "Choose file"}
        </span>
      </label>
      <input
        type="file"
        id="photo"
        className="hidden"
        accept=".png, .jpeg, .jpg "
        required
        onChange={handleFileChange}
      />
                          </div>
                          
                          <div>
                            <label 
                              htmlFor="fname"
                              className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >
                             First Name<span className='text-red-500'> *</span>
                            </label>
                            <input 
                            type="text"
                            name="fname"
                            id="fname"
                            value={trainer.fname}
                            onChange={handleInputChange}
                              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                              
                              />
                          </div>
                          <div>
                            <label
                              htmlFor="mname"
                              className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >
                          Middle Name<span className='text-red-500'> *</span>
                            </label>
                            <input
                              type="text"
                              name="mname"
                              id="mname"
                              value={trainer.mname}
                              onChange={handleInputChange}
                              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                            />
                          </div>
                           <div>
                            <label
                              for="lname"
                              className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >
                            Last Name<span className='text-red-500'> *</span>
                            </label>
                            <input
                              type="text"
                              id="lname"
                              name="lname"
                              value={trainer.lname}
                              onChange={handleInputChange}
                              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                            />
                          </div>
                          <div>
                            <label
                              for="qualifications"
                              className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >
                              Qualifications<span className='text-red-500'> *</span>
                            </label>
                            <input
                              type="text"
                              name="qualification"
                              id="qualification"
                              value={trainer.qualification}
                              onChange={handleInputChange}
                              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                            
                            />
                          </div>
                          <div>
                            <label htmlFor="qual"
                            className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >Qualification Certificate<span className='text-red-500'> *</span></label>
                            <label
        htmlFor="qual"
        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"      >
        <svg
          className="w-6 h-5 inline-block mr-2"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3 16V21H21V16H3ZM5 18H19V16H5V18ZM3 6H21V14H3V6ZM5 10H19V8H5V10Z"
            fill="currentColor"
          />
        </svg>
        <span className="inline-block">
          {" "}
          {qual?.name && qual.name.length > 8
            ? qual.name.substring(0, 8) + "..."
            : qual?.name || "Choose file"}
        </span>
      </label>
      <input
        type="file"
        id="qual"
        className="hidden"
        accept=".pdf"
        
        aria-autocomplete="true" 
        onChange={(e)=>setQual(e.target.files[0])}
      />
                          </div>
                          <div>
                          <label 
                          htmlFor="experience"
                           className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                Experience<span className='text-red-500'> *</span>
          </label>
          <input
            type="text"
            id="experience"
            name="experience"
            value={trainer.experience}
            onChange={handleInputChange}
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"/>
                            </div>
                            <div>
                            <label htmlFor="exp"
                            className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >Experience Certificate <span className='text-red-500'> *</span></label>
                            <label
        htmlFor="exp"
        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"      >
        <svg
          className="w-6 h-5 inline-block mr-2"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3 16V21H21V16H3ZM5 18H19V16H5V18ZM3 6H21V14H3V6ZM5 10H19V8H5V10Z"
            fill="currentColor"
          />
        </svg>
        <span className="inline-block">
          {" "}
          {exp?.name && exp.name.length > 8
            ? exp.name.substring(0, 8) + "..."
            : exp?.name || "Choose file"}
        </span>
      </label>
      <input
        type="file"
        id="exp"
        className="hidden"
        accept=".pdf"
        
        aria-autocomplete="true" 
        onChange={(e)=>setExp(e.target.files[0])}
      />
                          </div>
                            <div>
                              <label
                                htmlFor="district"
                               className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                              >
                                District <span className='text-red-500'> *</span>
                              </label>
                              <input
                                type="text"
                                id="district"
                                name="district"
                                value={trainer.district}
                                onChange={handleInputChange}
                                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
              />
                                </div>
                            <div>
                              <label
                                htmlFor="address"
                               className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                              >
                                Address<span className='text-red-500'> *</span>
                              </label>
                              <input
                                type="text"
                                id="address"
                                name="address"
                                value={trainer.address}
                                onChange={handleInputChange}
                                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"

                              />
                            </div>
                            <div>
                            <label
                                htmlFor="dob"
                               className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                              >
                                Date of Birth<span className='text-red-500'> *</span>
                              </label>
                              <input
                               type="date"
                               id="dob"
                               name="dob"
                               value={trainer.dob || `${new Date().getFullYear()-30}-01-01`}

                               
                               onChange={handleInputChange}
                              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                               />
                            </div>
                            <div>
                            <label  className="block mb-2 text-sm font-medium text-gray-900 dark:text-white" htmlFor="gender">
        Gender<span className='text-red-500'> *</span>
      </label>
        <select
          id="gender"
          onChange={(e)=>setGender(e.target.value)}
          value={gender}
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
        >
          <option value='' disabled>Select Gender</option>
          <option value="Male">Male</option>
          <option value="Female">Female</option>
          <option value="Other">Other</option>
        </select>
        <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
          
        </div>
      
                            </div>
                            <div >
      <label  className="block mb-2 text-sm font-medium text-gray-900 dark:text-white" htmlFor="marital-status">
        Marital Status<span className='text-red-500'> *</span>
      </label>
      <div >
        <select
          id="marital-status"
          onChange={(e)=>{
            setMStatus(e.target.value)
          }}
          value={mStatus}
      className="bg-gray-50 border border-gray-300 text-gratty-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
          <option value="" disabled>Select your status</option>
          <option value="Unmarried">Unmarried</option>  
          <option value="Married">Married</option>
          <option value="Divorced">Divorced</option>
          <option value="Widowed">Widowed</option>
        </select>
        <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
        </div>
      </div>
    </div>
                            <div>
                              <label htmlFor="email"
                               className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                               >
                                Email<span className='text-red-500'> *</span>
                               </label>
                               <input type="email"
                              id="email"
                              name="email"
                              value={trainer.email}
                              onChange={handleInputChange}
                              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"

                              />
                            </div>
                            
                            <div>
                              <label htmlFor="mo_no"  
                              className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                Mobile No.<span className='text-red-500'> *</span>
                                </label>
                              <input type="text"
                              id="mo_no"
                              name="mo_no"
                              value={trainer.mo_no}
                              onChange={handleInputChange}
                              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                              />
                            </div>
                            <div>
                              <label htmlFor="aadhar_no" 
                              className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Aadhar No.
                              <span className='text-red-500'> *</span></label>
                              <input
                              type="number"
                              id="aadhar_no"
                              maxLength={12}
                              name="aadhar_no"
                              value={trainer.aadhar_no}
                              onChange={handleInputChange}
                              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                              />
                            </div>
                            <div>
                            <label htmlFor="adhar"
                            className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >Upload Aadhar Card <span className='text-red-500'> *</span></label>
                            <label
        htmlFor="adhar"
        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"      >
        <svg
          className="w-6 h-5 inline-block mr-2"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3 16V21H21V16H3ZM5 18H19V16H5V18ZM3 6H21V14H3V6ZM5 10H19V8H5V10Z"
            fill="currentColor"
          />
        </svg>
        <span className="inline-block">
          {" "}
          {adhar?.name && adhar.name.length > 8
            ? adhar.name.substring(0, 8) + "..."
            : adhar?.name || "Choose file"}
        </span>
      </label>
      <input
        type="file"
        id="adhar"
        className="hidden"
        accept=".pdf"
        
        aria-autocomplete="true" 
        onChange={(e)=>setAdhar(e.target.files[0])}
      />
                          </div>
                            <div>
                              <label htmlFor="pan_no" 
                              className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                Pan No.<span className='text-red-500'> *</span></label>
                              <input
                              type="text"
                              id="pan_no" 
                              name="pan_no"
                              value={trainer.pan_no}
                              onChange={handleInputChange}
                              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                              />
                            </div>
                            <div>
                            <label htmlFor="pan"
                            className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >Upload Pan Card <span className='text-red-500'> *</span></label>
                            <label
        htmlFor="pan"
        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"      >
        <svg
          className="w-6 h-5 inline-block mr-2"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3 16V21H21V16H3ZM5 18H19V16H5V18ZM3 6H21V14H3V6ZM5 10H19V8H5V10Z"
            fill="currentColor"
          />
        </svg>
        <span className="inline-block">
          {" "}
          {pan?.name && pan.name.length > 8
            ? pan.name.substring(0, 8) + "..."
            : pan?.name || "Choose file"}
        </span>
      </label>
      <input
        type="file"
        id="pan"
        className="hidden"
        accept=".pdf"
        
        aria-autocomplete="true" 
        onChange={e=>setPan(e.target.files[0])}
      />
                          </div>
                            <div>
                            <label
                              htmlFor="alt_mob_no"
                              className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >
                             Alternate Mobile No.
                            </label>
                            <input 
                            type="text"
                            name="alt_mob_no"
                            id="alt_mob_no"
                            value={trainer.alt_mob_no}
                            onChange={handleInputChange}
                              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                              
                              />
                          </div>
                          <div>
                            <label
                              htmlFor="alt_email"
                              className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >
                             Alternate Email
                            </label>
                            <input 
                            type="text"
                            name="alt_email"
                            id="alt_email"
                            value={trainer.alt_email}
                            onChange={handleInputChange}
                              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                              
                              />
                          </div>
                        
                         <div><label
                              htmlFor="status"
                              className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >
                             Status <span className='text-red-500'> *</span>
                            </label>
                           <input type='text'
                            name="status"
                            id="status"
                            value={trainer.status}
                            onChange={handleInputChange}
                           className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                            /></div>
                             <div>
                            <label htmlFor="tot"
                            className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >ToT Certificate<span className='text-red-500'> *</span></label>
                            <label
        htmlFor="tot"
        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"      >
        <svg
          className="w-6 h-5 inline-block mr-2"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3 16V21H21V16H3ZM5 18H19V16H5V18ZM3 6H21V14H3V6ZM5 10H19V8H5V10Z"
            fill="currentColor"
          />
        </svg>
        <span className="inline-block">
          {" "}
          {tot?.name && tot.name.length > 8
            ? tot.name.substring(0, 8) + "..."
            : tot?.name || "Choose file"}
        </span>
      </label>
      <input
        type="file"
        id="tot"
        className="hidden"
        accept=".pdf"
        
        aria-autocomplete="true" 
        onChange={(e)=>setTot(e.target.files[0])}
      />
                          </div>
                            <div>
                            <label
                              htmlFor="payment"
                              className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >
                             Payment <span className='text-red-500'> *</span>
                            </label>
                            <input 
                            type="number"
                            name="payment"
                            id="payment"
                            value={trainer.payment}
                            onChange={handleInputChange}
                              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                              
                              />
                            </div>
                          
                          
                            <div>
                            <label htmlFor="cv"
                            className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >Upload CV <span className='text-red-500'> *</span></label>
                            <label
        htmlFor="cv"
        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"      >
        <svg
          className="w-6 h-5 inline-block mr-2"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3 16V21H21V16H3ZM5 18H19V16H5V18ZM3 6H21V14H3V6ZM5 10H19V8H5V10Z"
            fill="currentColor"
          />
        </svg>
        <span className="inline-block">
          {" "}
          {cv?.name && cv.name.length > 8
            ? cv.name.substring(0, 8) + "..."
            : cv?.name || "Choose file"}
        </span>
      </label>
      <input
        type="file"
        id="cv"
        className="hidden"
        accept=".pdf"
        
        aria-autocomplete="true" 
        onChange={(e)=>setCV(e.target.files[0])}
      />
                          </div>
                          <div>
                              <label htmlFor="username" 
                              className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                Username<span className='text-red-500'> *</span></label>
                              <input
                              type="text"
                              id="username" 
                              name="username"
                              value={trainer.username}
                              onChange={handleInputChange}
                              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                              />
                            </div>
                            <div>
                              <label htmlFor="password" 
                              className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                Password<span className='text-red-500'> *</span></label>
                              <input
                              type="text"
                              id="password" 
                              name="password"
                              value={trainer.password}
                              onChange={handleInputChange}
                              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                              />
                            </div>
                            <div className='row-span-10'>
      <MultiCourse
        selectedCourses={selectedCourses}
        onChange={handleCourseChange}
        isDisabled={false}
        imp={imp}
      />
    
    </div>
                                </div>
                                <div className="flex items-center space-x-4">
                           
                                </div>
                              </form>
                            </div>
                          </div>
                        </div>
                        <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                          <button
                            type="button"
                            className={`inline-flex w-full justify-center rounded-md px-3 py-2 text-sm font-semibold text-white shadow-sm sm:ml-3 sm:w-auto 
                              ${isButtonDisabled ? 'bg-gray-400 cursor-not-allowed' : 'bg-blue-600 hover:bg-blue-500'}`}
                              onClick={addTrainer}
                              disabled={isButtonDisabled}
                          >
                          {isButtonDisabled ? 'Adding...' : 'Add Trainer'}
                          </button>
                          <button
                            type="button"
                            className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                            onClick={() => addProductModalSetting()}
                            ref={cancelButtonRef}
                          >
                            Cancel
                          </button>
                        </div>
                      </Dialog.Panel>
                    </Transition.Child>
                  </div>
                </div>
              </Dialog>
            </Transition.Root>
          );
        }
